import { useState, useEffect } from 'react';

// 数据验证函数移到组件外部
const isValidState = (state) => {
  // 根据你的状态结构添加验证逻辑
  if (state === null || state === undefined) return false;
  // 添加更多验证规则...
  return true;
};

export const usePersistedState = (key, defaultValue) => {
  const [state, setState] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      if (item) {
        const parsed = JSON.parse(item);
        // 简单的数据验证
        if (isValidState(parsed)) {
          return parsed;
        }
      }
      return defaultValue;
    } catch (error) {
      console.error(`Error reading localStorage key "${key}":`, error);
      return defaultValue;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(state));
    } catch (error) {
      console.error(`Error setting localStorage key "${key}":`, error);
    }
  }, [key, state]);

  return [state, setState];
};
